import View from 'ln/view/View';

import {Video} from './Video';
import {Video as template} from 'templates/components/video';


export class VideoView extends View<Video>{

    public videoTag:HTMLVideoElement;

    public constructor() {
        super({ template });
    }

    protected init(): void {

        this.videoTag = this.node.querySelector( '[js="video"]' ) as HTMLVideoElement;

        Array.from( this.node.querySelectorAll( '[js="chapters"] .chapter' ) ).forEach( chapter => {
            chapter.addEventListener( 'click', this.goTo.bind( this ));
        })
    }

    private goTo( e:MouseEvent ){
        let target = e.currentTarget as HTMLElement;
        if( this.videoTag.readyState == 4 ){
            this.videoTag.currentTime = parseFloat( target.dataset.time );
            this.videoTag.play();
        }
    }
}
